import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { DadosContatoAba8DTO } from '../../model/DadosContatoAba8DTO';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable()
export class DadosContatoAba8 extends GenericService {
    private path = environment.url + 'api/v1/contato';

    constructor(http: HttpClient) {
        super(http);
    }

    getDadosContato(): Observable<DadosContatoAba8DTO> {
        return this.http.get<DadosContatoAba8DTO>(this.path);
    }

    atualizarDadosContato(data): Observable<any> {
        return this.http.post(this.path + '/salvar', data);
    }
}